import { useEnableUnitsOfMeasure } from '../feature-flags/hooks/use-enable-units-of-measure';
import { useUnitsOfMeasureFeatureGate } from './use-units-of-measure-feature-gate';

export const useIsUnitsOfMeasureAvailable = () => {
  const isLdEnabled = useEnableUnitsOfMeasure();
  const { isFeatureEnabled: isPlanEnabled } = useUnitsOfMeasureFeatureGate();

  return {
    isAvailable: isLdEnabled && isPlanEnabled,
    isLdEnabled,
    isPlanGated: isLdEnabled && !isPlanEnabled,
  };
};
